export const routes = {
  home: '/',
  about: '/o-mnie',
  qualifications: '/kwalifikacje',
  consultations: '/konsultacje',
  priceList: '/cennik',
  contact: '/kontakt',
};
